export const POST_LOGIN_CART_ERROR_COOKIE = "schaefflerPostLoginCartError";

const DELETE_COOKIE_VALUE = `${POST_LOGIN_CART_ERROR_COOKIE}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;

type CookieDocument = Pick<Document, "cookie">;

function readPostLoginCartErrorValues(cookieHeader: string): string[] {
  return cookieHeader.split(";").flatMap((rawCookie) => {
    const cookie = rawCookie.trimStart();
    const separatorIndex = cookie.indexOf("=");

    if (separatorIndex < 0 || cookie.slice(0, separatorIndex) !== POST_LOGIN_CART_ERROR_COOKIE) {
      return [];
    }

    return [cookie.slice(separatorIndex + 1)];
  });
}

/**
 * Consumes the non-authentication post-login cart-error signal.
 *
 * The backend writes only the literal value `1`. Any other value or more than one
 * same-name cookie is discarded without presentation so malformed or ambiguous browser
 * state cannot manufacture an error toast.
 */
export function consumePostLoginCartErrorCookie(cookieDocument: CookieDocument = document): boolean {
  const values = readPostLoginCartErrorValues(cookieDocument.cookie);

  if (values.length === 0) {
    return false;
  }

  cookieDocument.cookie = DELETE_COOKIE_VALUE;

  return values.length === 1 && values[0] === "1";
}
